// TODO: Fix!!
/* eslint-disable import/no-duplicates */
import React from 'react';
import i18n from 'i18next';
import LocaleModule from 'Locale';
import i18next from 'i18next';

const TRANSLATED_LANGUAGES_NS = 'translatedLanguages';
const Alpha3BCodeLength = 3;

const supportedLanguages = {
    br: () => require('@cospired/i18n-iso-languages/langs/br.json'),
    de: () => require('@cospired/i18n-iso-languages/langs/de.json'),
    fi: () => require('@cospired/i18n-iso-languages/langs/fi.json'),
    id: () => require('@cospired/i18n-iso-languages/langs/id.json'),
    ja: () => require('@cospired/i18n-iso-languages/langs/ja.json'),
    ms: () => require('@cospired/i18n-iso-languages/langs/ms.json'),
    pl: () => require('@cospired/i18n-iso-languages/langs/pl.json'),
    ru: () => require('@cospired/i18n-iso-languages/langs/ru.json'),
    vi: () => require('@cospired/i18n-iso-languages/langs/vi.json'),
    cz: () => require('@cospired/i18n-iso-languages/langs/cs.json'),
    cs: () => require('@cospired/i18n-iso-languages/langs/cs.json'),
    en: () => require('@cospired/i18n-iso-languages/langs/en.json'),
    fr: () => require('@cospired/i18n-iso-languages/langs/fr.json'),
    is: () => require('@cospired/i18n-iso-languages/langs/is.json'),
    lt: () => require('@cospired/i18n-iso-languages/langs/lt.json'),
    nl: () => require('@cospired/i18n-iso-languages/langs/nl.json'),
    pt: () => require('@cospired/i18n-iso-languages/langs/pt.json'),
    sv: () => require('@cospired/i18n-iso-languages/langs/sv.json'),
    zh: () => require('@cospired/i18n-iso-languages/langs/zh.json'),
    da: () => require('@cospired/i18n-iso-languages/langs/da.json'),
    es: () => require('@cospired/i18n-iso-languages/langs/es.json'),
    hu: () => require('@cospired/i18n-iso-languages/langs/hu.json'),
    it: () => require('@cospired/i18n-iso-languages/langs/it.json'),
    lv: () => require('@cospired/i18n-iso-languages/langs/lv.json'),
    no: () => require('@cospired/i18n-iso-languages/langs/no.json'),
    ro: () => require('@cospired/i18n-iso-languages/langs/ro.json'),
    th: () => require('@cospired/i18n-iso-languages/langs/th.json')
};

const addResourceBundle = (language) => {
    if (
        Object.prototype.hasOwnProperty.call(supportedLanguages, language) &&
        typeof supportedLanguages[language] === 'function'
    ) {
        const resources = supportedLanguages[language]();
        LocaleModule.addResourceBundle(language, TRANSLATED_LANGUAGES_NS, resources);
    }
};

const capitalizeLabel = (textTrackLabel) =>
    textTrackLabel.charAt(0).toUpperCase() + textTrackLabel.slice(1);

export const getTrackLabel = (track) => {
    const lang = i18next.language;
    const t = i18n.getFixedT(lang, TRANSLATED_LANGUAGES_NS);
    if (!i18next.hasResourceBundle(lang, TRANSLATED_LANGUAGES_NS)) {
        addResourceBundle(lang);
    }
    if (track.language && track.language.length === Alpha3BCodeLength) {
        const languages = require('@cospired/i18n-iso-languages');
        const alpha3BCodes = languages.getAlpha3BCodes();
        const filteredTrackLabel = alpha3BCodes[track.language]
            ? t(`${alpha3BCodes[track.language]}`)
            : track.language;
        return capitalizeLabel(filteredTrackLabel);
    }
    const trackLabel = t(`${track.language}`);
    return capitalizeLabel(trackLabel);
};
